import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Representa la información de los parametors de entrada referentes
 * al docuemnto del cliente
 */
class InputsDocumentDto {
}

/**
 * Representa la información para la petición al WS
 */
class RequestDto {
}

/**
 * Representa la información de respuesta del WS
 */
class ResponseDto {
}

/**
 * Representa la información del status de la respuesta a la petición al WS
 */
class StatusDto {
}

/**
 * Representa la información de la viabilidad del usuario
 */
class ViabilityDto {
}

/**
 * Representa la información de respuesta del WS
 */
class ViabilityDataDto {
}

class ViabilityApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see BasicDataApiService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'viability', 'Viability');
    }
    /**
     * Método encargado de consultar el web service de viabilidad del cliente y retornar la información
     * @param args Argumentos para la ejecucion del servicio
     * @returns Objeto de tipo @see ResponseDto con la información de viabilidad del cliente y sus tipologías
     * @example
     * // Gets affiliate basic data and typologies
     * this.service.getViability('CC', '1234').subscribe((x) => console.log(x));
     */
    getViability(args) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/GetViability`, args));
    }
    /**
     * Método encargado de consultar el web service de viabilidad del cliente a partir de la
     * informacion almacenada en los claims de identity server y retornar la información
     * @returns Objeto de tipo @see ResponseDto con la información de viabilidad del cliente y sus tipologías
     */
    getViabilityAuth() {
        return this.getUri((uri) => this.httpClient.get(`${uri}/GetViability`));
    }
    /**
    * Método encargado de consultar el web service de viabilidad del cliente y retornar la información
    * @param args Argumentos para la ejecucion del servicio
    * @returns Objeto de tipo @see ResponseDto con la información de viabilidad del cliente y sus tipologías
    * @example
    */
    getViabilityExternal(args) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/GetViabilityExternal`, args));
    }
    /**
    * Método encargado de consultar el web service de viabilidad del cliente a partir de la
    * informacion almacenada en los claims de identity server y retornar la información
    * @returns Objeto de tipo @see ViabilityDataDto con la información de viabilidad del cliente y sus tipologías
    */
    getViabilityAuthExternal() {
        return this.getUri((uri) => this.httpClient.get(`${uri}/GetViabilityRequestExternal`));
    }
}
ViabilityApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ViabilityApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ViabilityApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ViabilityApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.12", ngImport: i0, type: ViabilityApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of ws-viability
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InputsDocumentDto, RequestDto, ResponseDto, StatusDto, ViabilityApiService, ViabilityDataDto, ViabilityDto };
